module.exports = __webpack_public_path__ + "img/product3-2.827fb5ad.jpg";